import React from "react";

const MassActions = () => {
    return <div>MassActions</div>;
};

export default MassActions;
